import React from 'react';
import { List, ListItemButton, ListItemText, Typography, Box, Divider, Fade } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const EmailList = ({ emails, selectedEmail, handleEmailClick, formatDate, getEmailSnippet }) => {
  if (emails.length === 0) {
    return null; // The Welcome component will be shown instead
  }

  return (
    <List sx={{ p: 0, bgcolor: 'background.paper' }}>
      {emails.map((email, index) => {
        const isSelected = selectedEmail && selectedEmail.id === email.id;

        return (
          <Fade in={true} timeout={300} key={email.id}>
            <div>
              <ListItemButton
                selected={isSelected}
                onClick={() => handleEmailClick(email)}
                sx={{
                  py: 1.5,
                  px: 2,
                  '&.Mui-selected': {
                    bgcolor: 'action.hover',
                    '&:hover': {
                      bgcolor: 'action.hover',
                    },
                  },
                }}
              >
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: email.is_read ? 500 : 700,
                          color: email.is_read ? 'text.secondary' : 'text.primary',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {email.from}
                      </Typography>
                      {!email.is_read && (
                        <CircleIcon sx={{ fontSize: 10, color: 'primary.main', ml: 1, flexShrink: 0 }} />
                      )}
                    </Box>
                  }
                  secondary={
                    <>
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.primary"
                        sx={{
                          fontWeight: email.is_read ? 400 : 600,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: 'block',
                        }}
                      >
                        {email.subject || '(No Subject)'}
                      </Typography>
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: 'block',
                        }}
                      >
                        {getEmailSnippet(email.body)}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ textAlign: 'right', display: 'block', mt: 0.5 }}
                      >
                        {formatDate(email.received_at)}
                      </Typography>
                    </>
                  }
                />
              </ListItemButton>
              {index < emails.length - 1 && <Divider component="li" />}
            </div>
          </Fade>
        );
      })}
    </List>
  );
};

export default EmailList;
